import ConfirmDialog from "@/components/confirm-dialog/ConfirmDialog";
import ToolbarButton from "@/components/ToolbarButton";
import useSurvey from "@/containers/survey/hooks/useSurvey";
import { cn } from "@/lib/utils";
import { ArchiveX } from "lucide-react";
import { useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface ArchiveButtonProps {
  className?: string;
  labelClassName?: string;
}

export default function ArchiveButton({
  className,
  labelClassName,
}: ArchiveButtonProps) {
  const { t } = useTranslation();
  const survey = useSurvey();

  const { isSubmitting, disabled } = useFormState();

  const onConfirm = () => {
    survey.setArchiveFlag(true);
  };

  return (
    <ConfirmDialog
      title={t("surveyEditor.archiveDialog.title")}
      yesLabel={t("surveyEditor.archiveDialog.yesButton")}
      noLabel={t("surveyEditor.archiveDialog.noButton")}
      content={t("surveyEditor.archiveDialog.content")}
      onConfirm={onConfirm}
    >
      <ToolbarButton
        type="button"
        className={className}
        disabled={isSubmitting || disabled}
      >
        <ArchiveX className="w-5 h-5" />
        <span className={cn("ml-3", labelClassName)}>
          {t("surveyEditor.toolbar.archive")}
        </span>
      </ToolbarButton>
    </ConfirmDialog>
  );
}
